import script from "./OrderFulfillmentLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderFulfillmentLayout.vue?vue&type=script&setup=true&lang=js"

import "./OrderFulfillmentLayout.vue?vue&type=style&index=0&id=63d910b0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63d910b0"]])

export default __exports__